interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  isCheckbox?: boolean;
  filterable?: boolean;
}

export const EVoucherColumns: TableColumn[] = [
  { key: "select", header: "Select", isCheckbox: true },
  { key: "reportId", header: "Report ID"},
  { key: "merchant", header: "Merchant"},
  { key: "companyName", header: "Company Name"},
  { key: "totalAmount", header: "Total Amount"},
  { key: "noOfVoucher", header: "No of voucher" },
  { key: "submittedDate", header: "Submitted Date" },
  { key: "receivedDate", header: "Received Date" },
  { key: "rejectionReason", header: "Rejection Reason" },
  // { key: "createdBy", header: "Created By"},
  { key: "reportStatus", header: "Report Status"},
];

export const EVoucherColumns1: TableColumn[] = [
  { key: "reportId", header: "Report ID"},
  { key: "merchant", header: "Merchant"},
  { key: "companyName", header: "Company Name"},
  // { key: "voucherType", header: "Voucher Type", filterable: true },
  { key: "totalAmount", header: "Total Amount"},
  { key: "noOfVoucher", header: "No of voucher" },
  { key: "submittedDate", header: "Submitted Date" },
  { key: "receivedDate", header: "Received Date" },
  { key: "rejectionReason", header: "Rejection Reason" },
  // { key: "createdBy", header: "Created By"},
  { key: "reportStatus", header: "Report Status"},
];
